const instructions = {
  Eng: [
    "A live photo from you will be taken. Grant permission to access the camera and ensure you have good lighting. Do not wear hats or sunglasses.",
    "You will input your own password.",
    "Your current address."
  ],
  Spa: [
    " continuación requirimos su fotografia actual. Otorgue acceso a la cámara, asegúrate de tener buena iluminación y no usar gorras o lentes de sol.",
    "Ingresarás tu propia contraseña.",
    "Tu domicilio actual."
  ]
};

const Instructions = ({ language, setLanguage, nextStep }) => {
  return (
    <div className="flex flex-col items-center p-6">
      <div className="flex gap-4 mb-6">
        <button
          className={`p-2 rounded-full border-2 ${language === 'Eng' ? 'border-blue-500' : 'border-gray-300'}`}
          onClick={() => setLanguage('Eng')}
          aria-label="English"
        >
          {/* Colorful American Flag SVG */}
          <svg width="40" height="28" viewBox="0 0 40 28" fill="none">
            <rect width="40" height="28" rx="4" fill="#B22234"/>
            <g>
              <rect y="4" width="40" height="2" fill="#fff"/>
              <rect y="8" width="40" height="2" fill="#fff"/>
              <rect y="12" width="40" height="2" fill="#fff"/>
              <rect y="16" width="40" height="2" fill="#fff"/>
              <rect y="20" width="40" height="2" fill="#fff"/>
              <rect y="24" width="40" height="2" fill="#fff"/>
            </g>
            <rect width="16" height="12" rx="2" fill="#3C3B6E"/>
            {/* Stars */}
            <g>
              <circle cx="2" cy="2" r="0.7" fill="#fff"/>
              <circle cx="5" cy="2" r="0.7" fill="#fff"/>
              <circle cx="8" cy="2" r="0.7" fill="#fff"/>
              <circle cx="11" cy="2" r="0.7" fill="#fff"/>
              <circle cx="14" cy="2" r="0.7" fill="#fff"/>
              <circle cx="2" cy="5" r="0.7" fill="#fff"/>
              <circle cx="5" cy="5" r="0.7" fill="#fff"/>
              <circle cx="8" cy="5" r="0.7" fill="#fff"/>
              <circle cx="11" cy="5" r="0.7" fill="#fff"/>
              <circle cx="14" cy="5" r="0.7" fill="#fff"/>
              <circle cx="2" cy="8" r="0.7" fill="#fff"/>
              <circle cx="5" cy="8" r="0.7" fill="#fff"/>
              <circle cx="8" cy="8" r="0.7" fill="#fff"/>
              <circle cx="11" cy="8" r="0.7" fill="#fff"/>
              <circle cx="14" cy="8" r="0.7" fill="#fff"/>
              <circle cx="2" cy="11" r="0.7" fill="#fff"/>
              <circle cx="5" cy="11" r="0.7" fill="#fff"/>
              <circle cx="8" cy="11" r="0.7" fill="#fff"/>
              <circle cx="11" cy="11" r="0.7" fill="#fff"/>
              <circle cx="14" cy="11" r="0.7" fill="#fff"/>
            </g>
          </svg>
        </button>
        <button
          className={`p-2 rounded-full border-2 ${language === 'Spa' ? 'border-yellow-500' : 'border-gray-300'}`}
          onClick={() => setLanguage('Spa')}
          aria-label="Spanish"
        >
          {/* Colorful Spanish Flag SVG */}
          <svg width="40" height="28" viewBox="0 0 40 28" fill="none">
            <rect width="40" height="28" rx="4" fill="#AA151B"/>
            <rect y="6" width="40" height="16" fill="#F1BF00"/>
            {/* Coat of arms (simplified) */}
            <circle cx="8" cy="14" r="3" fill="#AA151B"/>
            <rect x="7" y="12" width="2" height="4" fill="#F1BF00"/>
          </svg>
        </button>
      </div>
      <div className="w-full max-w-md bg-white rounded-lg shadow p-6 mb-6">
        <h2 className="text-xl font-bold mb-4 text-center">
          {language === 'Eng' ? 'Instructions' : 'Instrucciones'}
        </h2>
        <ol className="list-decimal pl-6 space-y-2 text-gray-700">
          {instructions[language].map((step, idx) => (
            <li key={idx}>{step}</li>
          ))}
        </ol>
      </div>
      <button className="mt-2 px-6 py-2 bg-teal text-white rounded-lg font-semibold hover:bg-teal-700" onClick={nextStep}>
        {language === 'Eng' ? 'Next' : 'Siguiente'}
      </button>
    </div>
  );
};

export default Instructions;